import { render, staticRenderFns } from "./StatsWorstPerformersModal.vue?vue&type=template&id=17622fce&"
import script from "./StatsWorstPerformersModal.vue?vue&type=script&lang=js&"
export * from "./StatsWorstPerformersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports